import Constants from 'expo-constants';
import { Linking, Platform } from 'react-native';
import { AppReviewPromptPlatform, AppReviewPromptPublicReviewDestination } from '../api/api.g';

export interface AppReviewUrls {
  appStore?: string;
  googlePlay?: string;
}

export const getAppReviewPromptPlatform = (): AppReviewPromptPlatform => {
  if (Platform.OS === 'ios') {
    return AppReviewPromptPlatform.Ios;
  }

  if (Platform.OS === 'android') {
    return AppReviewPromptPlatform.Android;
  }

  return AppReviewPromptPlatform.Web;
};

export const getAppReviewUrls = (): AppReviewUrls => {
  return ((Constants.expoConfig?.extra as any)?.reviewUrls ?? {}) as AppReviewUrls;
};

export const getReviewUrlByDestination = (destination: AppReviewPromptPublicReviewDestination): string | undefined => {
  const reviewUrls = getAppReviewUrls();

  return destination === AppReviewPromptPublicReviewDestination.AppStore ? reviewUrls.appStore : reviewUrls.googlePlay;
};

export const openReviewDestination = async (destination: AppReviewPromptPublicReviewDestination) => {
  const reviewUrl = getReviewUrlByDestination(destination);

  if (reviewUrl) {
    await Linking.openURL(reviewUrl);
  }
};
